/**
 * <product-media-slider>
 *
 * Links the standalone product media slider to the PDP hero gallery: clicking a
 * slide drives the hero <slideshow-component> to the same media (matched by
 * media id, so it works even though the hero may sort/hide media differently),
 * then scrolls the hero into view so the change is visible.
 */
class ProductMediaSlider extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const slide = target.closest('[data-hero-media-id]');
    if (!slide) return;

    const mediaId = slide.getAttribute('data-hero-media-id');
    if (!mediaId) return;

    const heroSlideshow = document.querySelector(
      '.product-information__media slideshow-component, media-gallery slideshow-component'
    );
    if (!heroSlideshow || typeof heroSlideshow.select !== 'function') return;

    // The hero slides carry slide-id="{media.id}"; select by id (order-independent).
    heroSlideshow.select({ id: mediaId });

    // Bring the hero into view so the swapped main image is visible.
    const hero = document.querySelector('.product-information__media') || heroSlideshow;
    hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}

if (!customElements.get('product-media-slider')) {
  customElements.define('product-media-slider', ProductMediaSlider);
}
